import 'bootstrap';
import React from 'react';
import { PropTypes } from 'prop-types';
import { Provider } from 'react-redux';
import configureStore from 'store/configureStore';
import reducer from './screen/reducer';
import { default as Screen } from './screen';
import { setAPIBaseUrl, setDefaultHeader } from 'shared/api';
import { setInitialData } from './screen/actions';

const store = configureStore(reducer);

class App extends React.Component {
  constructor(props) {
    super(props);

    const {
      api_base_url,
      payment_request_token,
      initial_data
    } = props;

    setAPIBaseUrl(api_base_url);
    setDefaultHeader('X-Payment-Request-Token', payment_request_token);
    store.dispatch(setInitialData(initial_data));
  }

  render() {
    return (
      <Provider store={store}>
        <Screen />
      </Provider>
    );
  }
}

App.propTypes = {
  api_base_url: PropTypes.string.isRequired,
  payment_request_token: PropTypes.string.isRequired,
  initial_data: PropTypes.object.isRequired
};

export default App;
